import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useTheme, alpha, Typography } from '@mui/material';
export const ProgressBar = ({ value }) => {
    const theme = useTheme();
    // Clamp value between 0 and 100
    const pct = Math.max(0, Math.min(100, Number(value) || 0));
    return (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', width: '100%', gap: 1, mt: 1, mb: 1 }, children: [pct > 0 && (_jsx(Box, { sx: {
                    display: 'flex',
                    width: `${pct}%`,
                    height: 34,
                    px: 1,
                    py: 0.5,
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    borderRadius: 1,
                    background: 'linear-gradient(135deg,#22C55E 0%, #118D57 100%)',
                    color: '#fff',
                    fontWeight: 400
                }, children: _jsx(Typography, { variant: 'body2', noWrap: true, fontWeight: 400, color: 'inherit', children: `${pct}% used` }) })), pct < 100 && (_jsx(Box, { sx: {
                    display: 'flex',
                    width: `${100 - pct}%`,
                    height: 34,
                    px: 1,
                    py: 0.5,
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 1,
                    backgroundColor: alpha(theme.palette.success.main, 0.16),
                    color: 'text.primary',
                    fontWeight: 600
                } }))] }));
};
